export const author = {
  relatedArticles: "Articles from {{name}}",
};
